<template>
  <div>
    <HeaderTwo v-if="currentUrl == '/web-hosting'"></HeaderTwo>
    <HeaderThree v-else-if="currentUrl == '/machine-learning'"></HeaderThree>
    <HeaderFour v-else-if="currentUrl == '/digital-agency'"></HeaderFour>
    <!-- <HeaderFour v-else-if="currentUrl == '/digital-agency'"></HeaderFour> -->
    <div v-else-if="currentUrl == '/not-found' || currentUrl == '/coming-soon'"></div>
    <SmatHeader v-else></SmatHeader>
    <!-- <Header v-else></Header> -->
    <PreLoader v-if="isLoading" />
    <router-view></router-view>
    <div v-if="currentUrl == '/not-found' || currentUrl == '/coming-soon'"></div>
    <!-- <Footer v-else></Footer> -->
    <SmatFooter v-else></SmatFooter>
  </div>
</template>

<script>
// import Header from './components/layout/Header';
import SmatHeader from './components/layout/SmatHeader';
import HeaderTwo from './components/layout/HeaderTwo';
import HeaderThree from './components/layout/HeaderThree';
import HeaderFour from './components/layout/HeaderFour';
// import Footer from './components/layout/Footer';
import SmatFooter from './components/layout/SmatFooter';
import PreLoader from './components/layout/PreLoader';
export default {
  name: 'app',
  components: {
    SmatHeader, HeaderTwo, HeaderThree, HeaderFour, SmatFooter, PreLoader
  },

  data() {
    return {
      isLoading: false,
      currentUrl: ''
    }
  },

  watch: {
    '$route'(pathUrl){
      this.currentUrl = pathUrl.path;
      // this.isLoading = true;
      // setTimeout(() => { this.isLoading = false }, 1500);
    }
  },

  mounted() {
    this.currentUrl = window.location.pathname;
    // setTimeout(() => {
    //   this.isLoading = false
    // }, 2000);
  }
}
</script>
